import { useMemo } from 'react';
import { useListInvestmentPlansQuery } from '../../features/investmentPlans/investmentPlansApi';

/**
 * Investment objects only carry investment_plan_uuid, never the plan's
 * name/photo inline (confirmed by the documented response shape) — this
 * cross-references the already-integrated plan catalog (GET
 * /investor/investment-plans, open to any authenticated user including
 * admins) to resolve a uuid into a display-ready plan, everywhere an
 * investment is listed. Returns null for a uuid that isn't in the catalog
 * rather than guessing a name.
 */
export function usePlanLookup() {
  const { data } = useListInvestmentPlansQuery();
  const plans = data ?? [];

  return useMemo(() => {
    const map = new Map(plans.map((p) => [p.id, p]));
    return (uuid) => (uuid ? map.get(uuid) ?? null : null);
  }, [plans]);
}

export default usePlanLookup;
